module.exports = __webpack_public_path__ + "static/media/Piano_After.11fd0020.jpg";